<router-outlet></router-outlet>
<app-loader></app-loader>
<app-error-alert-popup></app-error-alert-popup>
<app-error-alert-popup-ctba></app-error-alert-popup-ctba>
<app-toast></app-toast>

<!-- Global SVG Definitions -->
<svg width="0" height="0" style="position:absolute; width:0; height:0;">
  <defs>
    <linearGradient id="askme-gradient" x1="0" y1="0" x2="24" y2="24" gradientUnits="userSpaceOnUse">
      <stop offset="0%" stop-color="#8600CD" />
      <stop offset="100%" stop-color="#1110EB" />
    </linearGradient>
  </defs>
</svg>
